import { render, staticRenderFns } from "./VegetalSalesRank.vue?vue&type=template&id=b1b5401e&scoped=true"
import script from "./VegetalSalesRank.vue?vue&type=script&setup=true&lang=js"
export * from "./VegetalSalesRank.vue?vue&type=script&setup=true&lang=js"
import style0 from "./VegetalSalesRank.vue?vue&type=style&index=0&id=b1b5401e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b5401e",
  null
  
)

export default component.exports